import styled from '@emotion/styled';

export const CtaBadge = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  padding: 12px 8px;
  border-radius: 2px;
  color: #fff;
  background: ${({theme}) => theme.colors.contentPromotionA};
  white-space: nowrap;
  letter-spacing: 1px;
  line-height: 1;

  ${({theme}) => theme.elevations.large};

  > b {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
    white-space: nowrap;
    padding: 2px 0;
  }
`;
